import { CheckoutService as MsCheckoutService, ProductCatalogService } from '@yol-digital/ms-client';
import { prismicToHtmlString, PromotionDocument } from 'prismic';

export class Promotion {
  public priority: number;
  public id?: string;
  public code?: string;
  public activationFeeDiscount?: number;
  public discountAmount?: number;
  public discountDuration?: number;
  public title?: string;
  public lockinLengths?: number[];
  public channels?: { id: string; availability: 'Default' | 'Non default' }[];

  constructor(
    promotion: ProductCatalogService.CatalogResponse['defaultPromotion'] | MsCheckoutService.Promotion,
    promotionFromPrismic?: PromotionDocument
  ) {
    this.id = promotion?.id;
    this.code = promotion?.code;
    this.activationFeeDiscount = promotion?.activationFeeDiscount;
    this.discountAmount = promotion?.discount;
    this.discountDuration = promotion?.duration;
    this.title = promotionFromPrismic ? prismicToHtmlString(promotionFromPrismic.data.title) : promotion?.displayName;
    this.priority = promotionFromPrismic?.data.priority;
    this.lockinLengths = promotion?.availableLockings;
  }

  public static discountPercentage(base?: number, discount?: number) {
    const discountedPrice = base - discount;
    if (typeof discountedPrice === 'number' && !Number.isNaN(discountedPrice)) {
      return Math.floor(((base - discountedPrice) / base) * 100);
    }
    return 0;
  }
}
